module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.9882/images/email-tracking-flow/email-confirmation.png"